/* Section-scoped custom element also initializes on Shopify section reloads. */
(() => {
  if (customElements.get('gds-bur-collection')) return;
  customElements.define('gds-bur-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.grid = this.querySelector('.gds-bur__grid');
      this.querySelectorAll('[data-controls]').forEach(el => { el.hidden = false; });
      const filters = this.querySelector('.gds-bur__filters');
      if (filters && window.matchMedia('(max-width: 850px)').matches) filters.open = false;
      this.cards.forEach(card => this.updateCard(card));
      this.addEventListener('change', event => {
        if (event.target.matches('input[name="id"]')) this.updateCard(event.target.closest('[data-card]'));
        else if (event.target.matches('[data-stock], [data-sort], [data-min], [data-max]')) this.filter();
      }, options);
      this.addEventListener('input', event => {
        if (event.target.matches('[data-min], [data-max]')) this.filter();
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-clear]')) {
          this.querySelectorAll('[data-min], [data-max]').forEach(input => { input.value = ''; });
          const stock = this.querySelector('[data-stock]');
          if (stock) stock.value = 'all';
          this.filter();
        }
      }, options);
      this.addEventListener('submit', event => {
        const form = event.target.closest('.gds-bur__form');
        if (!form) return;
        event.preventDefault();
        event.stopPropagation();
        this.addToCart(form);
      }, options);
      this.filter();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.ready = false;
    }
    updateCard(card) {
      const choice = card.querySelector('input[name="id"]:checked');
      if (!choice) return;
      // V6: keep a small shank label immediately above the selected price.
      const pricing = card.querySelector('.gds-bur__pricing');
      const optionText = choice.closest('.gds-bur__choice')?.querySelector('label span')?.textContent?.trim() || '';
      const shankText = /^Shank\s*#?\s*[13]\b/i.test(optionText) ? optionText.replace(/\s*\|\s*/g, ' · ') : '';
      if (pricing) {
        let shankLabel = pricing.querySelector('[data-selected-shank]');
        if (!shankLabel) {
          shankLabel = document.createElement('span');
          shankLabel.dataset.selectedShank = '';
          shankLabel.className = 'gds-bur__selected-shank';
          shankLabel.style.cssText = 'display:block;font-size:12px;font-weight:400;line-height:1.5;color:#626b79;margin:0 0 6px;letter-spacing:normal;text-transform:none;';
          pricing.prepend(shankLabel);
        }
        shankLabel.textContent = shankText;
        shankLabel.hidden = !shankText;
      }
      card.querySelector('[data-price]').textContent = choice.dataset.money;
      const compare = card.querySelector('[data-compare]');
      compare.textContent = choice.dataset.compare || '';
      compare.hidden = !choice.dataset.compare;
      card.querySelectorAll('[data-product-link]').forEach(a => { a.href = choice.dataset.url; });
      const sub = card.querySelector('[data-sub]');
      if (sub) {
        sub.href = choice.dataset.subUrl || choice.dataset.url;
        sub.hidden = !choice.dataset.subMoney;
        sub.querySelector('[data-sub-price]').textContent = choice.dataset.subMoney || '';
      }
      const button = card.querySelector('[data-add]');
      if (!card.dataset.busy) {
        button.disabled = choice.disabled;
        button.textContent = choice.disabled ? 'Sold out' : button.dataset.planRequired ? 'Choose subscription' : 'Add to Cart';
      }
      card.querySelector('[data-message]').hidden = true;
    }
    filter() {
      const stock = this.querySelector('[data-stock]')?.value || 'all';
      const minValue = this.querySelector('[data-min]')?.value || '';
      const maxValue = this.querySelector('[data-max]')?.value || '';
      const min = minValue === '' ? 0 : Math.max(0, Number(minValue) * 100);
      const max = maxValue === '' ? Infinity : Number(maxValue) * 100;
      const sort = this.querySelector('[data-sort]').value;
      let count = 0;
      this.cards.forEach(card => {
        const matches = Array.from(card.querySelectorAll('input[name="id"]')).filter(v => {
          const price = Number(v.dataset.price);
          const available = v.dataset.available === 'true';
          return price >= min && price <= max && (stock === 'all' || (stock === 'in' ? available : !available));
        });
        card.hidden = matches.length === 0;
        if (!card.hidden) count++;
        card.dataset.sortPrice = matches.length ? Math.min(...matches.map(v => Number(v.dataset.price))) : card.dataset.minPrice;
        // Keep the displayed variant consistent with active filters.
        const current = card.querySelector('input[name="id"]:checked');
        if (matches.length && !matches.includes(current)) {
          const next = matches.find(v => !v.disabled) || matches[0];
          next.checked = true;
          this.updateCard(card);
        }
      });
      const sorted = this.cards.slice().sort((a, b) => {
        if (sort === 'az') return a.dataset.title.localeCompare(b.dataset.title);
        if (sort === 'za') return b.dataset.title.localeCompare(a.dataset.title);
        if (sort === 'low') return Number(a.dataset.sortPrice) - Number(b.dataset.sortPrice);
        if (sort === 'high') return Number(b.dataset.sortPrice) - Number(a.dataset.sortPrice);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      sorted.forEach(card => this.grid.appendChild(card));
      this.querySelector('[data-count]').textContent = `${count} product ${count === 1 ? 'group' : 'groups'}`;
      this.querySelector('[data-empty]').hidden = count > 0;
    }
    async addToCart(form) {
      const card = form.closest('[data-card]');
      if (card.dataset.busy) return;
      const chosen = form.querySelector('input[name="id"]:checked');
      if (!chosen || chosen.disabled || !form.reportValidity()) return;
      const button = form.querySelector('[data-add]');
      if (button.dataset.planRequired) { window.location.assign(chosen.dataset.url); return; }
      const quantity = Number(form.elements.quantity.value);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      card.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = 'Adding…';
      const message = form.querySelector('[data-message]');
      message.hidden = true;
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(chosen.value), quantity }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This option could not be added. Please check availability and try again.');
        // A cart-page reload keeps Empire's cart count and app integrations in sync.
        window.location.assign(this.dataset.cart || `${root}cart`);
      } catch (error) {
        delete card.dataset.busy;
        this.updateCard(card);
        message.textContent = error instanceof TypeError ? 'Connection interrupted. Check your cart before retrying, to avoid adding twice.' : error.message;
        message.hidden = false;
      }
    }
  });
})();
